import { stopEventPropagation } from '../../../../../ui/features/badge-management/utils/stopEventPropagationHandler';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { ModalSlideoutActions } from '@juvare/common-web-ui/ModalSlideout';
import { Box, Button, Stack } from '@mui/material';
import React from 'react';
import { PrintBadgeButton } from '../AccountBadgeTable/PrintBadgeButton';
export const AccountBadgeSlideoutBottomActions = (props) => {
    const actionElements = useAccountBadgeSlideoutBottomActions(props);
    if (!actionElements.length) {
        return;
    }
    return (React.createElement(ModalSlideoutActions, null,
        React.createElement(Box, { sx: { p: 2, width: '100%' } },
            React.createElement(Stack, { direction: 'row', gap: 2 }, actionElements))));
};
function useAccountBadgeSlideoutBottomActions({ accountBadge, accountBadgeActions, onClose, onRefetch, renderCustomBottomActions, }) {
    const { t } = useBadgingTranslation();
    if (renderCustomBottomActions) {
        return renderCustomBottomActions({
            accountBadge,
            accountBadgeActions,
            onRefetch,
            onClose,
        });
    }
    const actionElements = [];
    if (accountBadgeActions.canRevoke) {
        actionElements.push(React.createElement(Button, { variant: 'outlined', size: 'large', color: 'info', onClick: stopEventPropagation(accountBadgeActions.handleAccountBadgeRevoke), sx: { width: '100%' } }, t('badges.badgeDetails.accountBadgeTable.actions.revoke')));
    }
    if (accountBadgeActions.canPrint) {
        actionElements.push(React.createElement(PrintBadgeButton, { accountBadge: accountBadge, onRefetch: onRefetch, variant: 'contained', size: 'large', sx: { width: '100%' } }));
    }
    if (accountBadgeActions.canNotify) {
        actionElements.push(React.createElement(Button, { variant: 'contained', size: 'large', color: 'info', onClick: stopEventPropagation(accountBadgeActions.handleAccountBadgeNotificationSend), sx: { width: '100%' } }, t('badges.badgeDetails.accountBadgeTable.actions.sendNotification')));
    }
    if (accountBadgeActions.canReissue) {
        const handleReissue = () => {
            accountBadgeActions.handleAccountBadgeReissue({
                onActionSuccess: () => onRefetch().then(() => onClose(false)),
            });
        };
        actionElements.push(React.createElement(Button, { variant: 'contained', size: 'large', color: 'info', onClick: handleReissue, sx: { width: '100%' } }, t('badges.badgeDetails.accountBadgeTable.actions.reissue')));
    }
    return actionElements;
}
